import m from 'mithril';
import AdyenCheckout from '@adyen/adyen-web';
import app from '../app';
import utils from '../lib/utils';
import paymentSession from '../lib/paymentSession';

const vwAdyenDropin = {
	dropin: null,
	config: {},
	oninit: async () => {
		const paymentAmount = {
			value: utils.convertToCents(app.paymentSession.amount),
			currency: app.paymentSession.currency,
		};

		vwAdyenDropin.config = {
			darkMode: true,
			paymentMethodsResponse: {
				paymentMethods: app.adyen.paymentMethods,
			},
			clientKey: app.adyen.clientKey,
			locale: app.paymentSession.locale ?? app.locale,
			environment: app.live ? 'live' : 'test',
			analytics: {
				enabled: false,
			},
			amount: paymentAmount,
			paymentMethodsConfiguration: {
				googlepay: {
					environment: app.live ? 'PRODUCTION' : 'TEST',
					countryCode: app.adyen.countryCodes?.googlepay ?? app.adyen.countryCodes.default,
					amount: paymentAmount,
				},
				applepay: {
					amount: paymentAmount,
					countryCode: app.adyen.countryCodes?.applepay ?? app.adyen.countryCodes.default,
				},
			},
			onSubmit: async (state, dropin) => {
				const result = await paymentSession.createPayment(state.data.paymentMethod, state.data.browserInfo);

				if (result.success === false) {
					await paymentSession.validateSession();

					vwAdyenDropin.dropin.unmount();
					vwAdyenDropin.dropin.mount('#dropin-container');

					//todo: add notification
					alert('Failed to create payment session try again');
					return;
				}

				if (result.data.adyen?.action) {
					dropin.handleAction(result.data.adyen.action);
					return;
				}

				paymentSession.showConfirmation();
			},
			onAuthorized: async (state, dropin) => {
				const result = await paymentSession.getSessionDetails(state.data);

				if (result === false) {
					await paymentSession.validateSession();
				} else if (result.data.adyen?.action) {
					dropin.handleAction(result.data.adyen.action);
					return;
				}

				paymentSession.showConfirmation();
			},
			onAdditionalDetails: async (state, dropin) => {
				const result = await paymentSession.getSessionDetails(state.data);

				if (result === false) {
					await paymentSession.validateSession();
				} else if (result.data.adyen?.action) {
					dropin.handleAction(result.data.adyen.action);
					return;
				}

				paymentSession.showConfirmation();
			},
		};

		const checkout = await AdyenCheckout(vwAdyenDropin.config);

		vwAdyenDropin.dropin = checkout
			.create('dropin', {
				openFirstPaymentMethod: true,
			})
			.mount('#dropin-container');
	},
	view: () => {
		return m('div', { id: 'dropin-container' });
	},
};

export default vwAdyenDropin;
